// extracted by mini-css-extract-plugin
module.exports =  {"clear":"GuvXHIPMoqEs9BrvwB82"};